import * as globals from '@wandb/common/css/globals.styles';
import styled, {css} from 'styled-components';

export type BannerVariant = 'announcement' | 'error' | 'info' | 'warning';

export const BANNER_VARIANTS: {[key: string]: BannerVariant} = {
  ANNOUNCEMENT: 'announcement',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
};

export const BannerWrapper = styled.div<{variant: string}>`
  display: flex;
  justify-content: space-between;

  border-radius: 8px;
  padding: 16px;

  ${({variant}) => {
    switch (variant) {
      case BANNER_VARIANTS.ANNOUNCEMENT:
        return css`
          background-color: ${globals.GOLD_DARK_TRANSPARENT};
          color: ${globals.GOLD_DARK_2};
        `;
      case BANNER_VARIANTS.ERROR:
        return css`
          background-color: ${globals.RED_TRANSPARENT};
          color: ${globals.RED};
        `;
      case BANNER_VARIANTS.WARNING:
        return css`
          background-color: ${globals.SIENNA_TRANSPARENT};
          color: ${globals.SIENNAS.SIENNA_DARK};
        `;
      case BANNER_VARIANTS.INFO:
      default:
        return css`
          background-color: ${globals.GRAY_TRANSPARENT};
          color: ${globals.GRAY_800};
        `;
    }
  }};

  font-family: Source Sans Pro;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  font-weight: 400;
`;

export const BannerFlexWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const BannerTextWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const BannerBoldText = styled.span`
  font-weight: 600;
`;
